// extracted by mini-css-extract-plugin
export default {"main":"Header_main__PaJ2i","border":"Header_border__9dbOA","logo":"Header_logo__kZk3P"};